module.exports = __webpack_public_path__ + "static/media/bgimage.8edb8822.jpg";